<div class="container mt-4 option-row position-relative">
  <!-- style="margin-left: 0px; width: 720px" -->
  <h2 class="gift-card-title">
    <img
      *ngIf="isMobile == true" (click)="mobileBack()"
      [src]="environment1 + 'assets/images/arrow-left.webp'"
      class="img-fluid me-2"
      loading="lazy"
      style="height: 24px"
    />
    {{storedReward.product}}
  </h2>
  <div class="tnc-wrapper d-flex align-items-center" (click)="TnCredirect()">
    <span class=" me-1">T&C applied</span>
    <img [src]='environment1 + "assets/images/chevron-right.svg"' alt="">
  </div>
  <div class="d-flex align-items-center justify-content-between">
    <!-- <p class="text-muted mb-0 shopping-text">(Shopping)</p>
    <p class="text-primary offer-text mb-0">15% off upto ₹500</p> -->
  </div>

  <hr />

  <div class="row">
    <div class="col-lg-6 col-12 card-image-container">
      <!-- <img
        [src]="environment1 + 'assets/images/' + storedReward?.image + '.webp'"
        alt="Amazon Gift Card"
        class="img-fluid card-image"
      /> -->
       <img

        [src]="storedReward.images !== null && storedReward.images[3] ? storedReward?.images[3]?.image_url : '../../../../assets/images/amazon-giftcard.png'"
        alt="Amazon Gift Card"
        class="img-fluid card-image"
      />
    </div>
    <div class="col-lg-6 col-12 right-column">
      <div class="d-flex align-items-center justify-content-between">
        <h5 class="select-options-title">Select options</h5>
        <p class="balance-text">Balance: ₹{{ balance }}</p>
      </div>

      <!-- Hide this part on mobile screens -->
      <div *ngFor="let option of options" class="row mb-3 align-items-center">
        <!-- <div class="col-6 col-md-3" style="display: flex;">
            <span class="option-amount" [ngClass]="{ 'text-primary': option === 1000 }">₹{{ option }}</span>

            <span *ngIf="option === 1000" class="badge badge-popular ms-2">Popular</span>

        </div> -->

        <div class="col-6 col-md-3 d-flex align-items-center">
          <button
            class="option-amount btn btn-option me-2"
            [ngClass]="{ 'text-primary': option === 1000 }"
            [ngStyle]="
              option === 1000
                ? {
                    width: '135px',
                    height: '40px',
                    display: 'flex',
                    'background-color': '#F7F7F7'
                  }
                : {}
            "
          >
            ₹{{ option }}
            <span *ngIf="option === 1000" class="badge badge-popular btn ms-2"
              >Popular</span
            >
          </button>

          <!-- <span *ngIf="option === 1000" class="badge badge-popular btn ms-2">Popular</span> -->
        </div>

        <div class="col-6 col-md-9">
          <div class="d-flex justify-content-end">
            <button class="btn btn-rounded me-2" (click)="decrease(option)">
              -
            </button>
            <input
              type="text"
              class="form-control form-control-quantity"
              [value]="getQuantity(option)"
              readonly
            />
            <button class="btn btn-rounded ms-2" (click)="increase(option)">
              +
            </button>
          </div>
        </div>
      </div>
      <p *ngIf="showAlert" class="custom-alert mt-3">
        You cannot select more than the available balance!
      </p>

      <button
        class="btn btn-primary col-12 btn-lg ps-5 pe-5 pt-md-3 pb-md-3 redeem-btn"
        [disabled]="totalSelected === 0"
        (click)="redeem()"
        style="
        background: linear-gradient(99.61deg, #1c429e 1.46%, #0a0a5f 101.08%);
        border: none;
      "
      >
        Redeem for {{ totalSelected  }} Points
      </button>
    </div>
  </div>

</div>
